import dom from "../../../../common/ts/core/dom";
import {EventBus} from "../../../../common/ts/events/EventBus";
import tracking from "../../../../common/ts/core/tracking";
import {SECTION_CLICKED_EVENT_TYPE} from "../../../../common/ts/tracking/constants";
import {Section, SectionId} from "../../../../common/ts/services/Section";
import PageData from "../../../../common/ts/PageData";
import favoritesIconMarker from "../../../../common/ts/components/core/favorites/FavoritesIconMarker";

dom.init()

const NAVBAR_ACCESS_ACCOUNT = "#navbar-access-account";
const pageData: PageData = window.wl.pageData

dom.select(NAVBAR_ACCESS_ACCOUNT)?.addEventListener('click', () => {
    trackClick();
});

favoritesIconMarker.handleMarkerState();

function trackClick() {
    EventBus.getInstance().emit(new tracking.TrackWebTrackingEvent({
        type: SECTION_CLICKED_EVENT_TYPE,
        serpUrl: window.location.href,
        sectionName: Section.SECTION_HEADER_REGISTER_LOGIN_BUTTON,
        section: SectionId.SECTION_HEADER_REGISTER_LOGIN_BUTTON.toString(),
        pageViewId: pageData.pageViewId || "",
    }));
}
